import axios from "@/libs/api.request";
export const getRoleMapping = params => {
  return axios.request({
    url: "/user/roleMapping",
    method: "GET",
    params
  });
};
export const getDetails = id => {
  return axios.request({
    url: `/user/roleMapping/${id}`,
    method: "GET"
  });
};
export const del = id => {
  return axios.request({
    url: `/user/roleMapping/${id}`,
    method: "DELETE"
  });
};
export const update = data => {
  return axios.request({
    url: `/user/roleMapping/${data.id}`,
    method: "PUT",
    data
  });
};
export const add = data => {
  return axios.request({
    url: "/user/roleMapping",
    method: "POST",
    data
  });
};
